import { Fragment, useCallback, useEffect, useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import { Grid, TextField } from '@material-ui/core';
import { ConfirmButton, CancelButton, useStyles } from './ExaminerAssignNumber.styles';
import { SelectedExaminer } from '../../../services/examiners/examiners.types';
import { useTranslation } from 'react-i18next';

interface ExaminerAssignNumberProps {
  open: boolean;
  examiners: SelectedExaminer[];
  confirm: (data: SelectedExaminer[]) => void;
  cancel: () => void;
  isBold?: boolean;
  closeDialogs?: () => void;
}

export default function ExaminerAssignNumber(props: ExaminerAssignNumberProps): JSX.Element {
  const { t } = useTranslation();

  const [open, setOpen] = useState<boolean>(false);
  const [examinerNumbers, setExaminerNumbers] = useState<SelectedExaminer[]>([]);
  const [isAddButtonDisable, setIsAddButtonDisable] = useState<boolean>(false);

  useEffect(() => {
    setOpen(props.open);
  }, [props.open]);

  useEffect(() => {
    if (props.examiners) {
      setExaminerNumbers(props.examiners);
    }
  }, [props.examiners]);

  const classes = useStyles();

  const sendDataToParent = useCallback(() => {
    setIsAddButtonDisable(true);
    props.confirm(examinerNumbers);
  }, [examinerNumbers]);

  const saveExaminerNumbers = (examinerNumber: string, userId: string) => {
    setExaminerNumbers((state) =>
      state.map((examiner) => {
        if (examiner.userId === userId) {
          examiner.examinerNumber = examinerNumber.trim();
        }
        return examiner;
      }),
    );
  };
  const setExaminerNumberByUserId = (userIdParam: string): string => {
    const foundExaminer: SelectedExaminer | undefined = examinerNumbers.find((e) => e.userId === userIdParam);
    return foundExaminer ? (foundExaminer.examinerNumber ? foundExaminer.examinerNumber : '') : '';
  };
  const isDisable = (examiner: SelectedExaminer): boolean => {
    if (!examiner.examinerNumber) {
      return true;
    }
    if (examiner.examinerNumber !== undefined) {
      return examiner.examinerNumber.length === 0;
    }
    return false;
  };
  useEffect(() => {
    const hasUserWithoutNumber: SelectedExaminer[] = examinerNumbers.filter(isDisable);
    setIsAddButtonDisable(hasUserWithoutNumber.length > 0);
  }, [examinerNumbers]);

  return (
    <Dialog
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          props.cancel();
        }
      }}
      aria-label="Przypisz numer egzaminatora"
      open={open}
    >
      <Grid item xs={12}>
        <div className={classes.modalTitle}>Przypisz numer egzaminatora</div>
      </Grid>
      <div className={classes.formFields}>
        {props.examiners.map((examiner) => {
          const isInputDisable = isDisable(examiner);
          return (
            <Fragment key={`${examiner.userId}-${examiner.firstName}`}>
              <div className={classes.subHeader}>
                {examiner.firstName} {examiner.lastName}
              </div>
              <TextField
                type={'text'}
                error={isInputDisable}
                helperText={isInputDisable ? 'Pole wymagane' : ''}
                className={classes.formInput}
                id="outlined"
                label="Numer egzaminatora*"
                variant="outlined"
                onChange={(e) => {
                  saveExaminerNumbers(e.target.value.trimStart(), examiner.userId);
                }}
                value={setExaminerNumberByUserId(examiner.userId)}
                inputProps={{
                  style: {
                    padding: '15.5px',
                    color: '#2C2D3E',
                  },
                }}
                InputLabelProps={{
                  style: { color: '#2C2D3E' },
                }}
                FormHelperTextProps={{
                  style: {
                    fontSize: '11px',
                    color: '#BC0000',
                  },
                }}
              />
            </Fragment>
          );
        })}
      </div>

      <Grid container style={{ marginTop: '10px', marginBottom: '22px' }}>
        <Grid item xs={12}>
          <CancelButton onClick={props.cancel}>Anuluj</CancelButton>
          <ConfirmButton disabled={isAddButtonDisable} onClick={sendDataToParent}>
            Zapisz
          </ConfirmButton>
        </Grid>
      </Grid>
    </Dialog>
  );
}
